/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryResponse } from '../../models/country-response';

export interface GetCountries$Params {
}

export function getCountries(http: HttpClient, rootUrl: string, params?: GetCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CountryResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCountries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CountryResponse>>;
    })
  );
}

getCountries.PATH = '/api/countries';
